<template>
    <div class="container-server">
        <el-row :gutter="12">
            <el-col :span="12">
                <el-card class="box-card noBorder">
                    <template #header>
                        <div class="card-header">
                            <span>CPU</span>
                        </div>
                    </template>
                    <el-descriptions direction="vertical" :column="2" :size="size" border class="desc-list">
                        <el-descriptions-item label="属性">核心数</el-descriptions-item>
                        <el-descriptions-item label="值">{{ cpu && cpu.cpu_count }}</el-descriptions-item>
                        <el-descriptions-item>用户使用率</el-descriptions-item>
                        <el-descriptions-item>{{ cpu && cpu.cpu_user }}%</el-descriptions-item>
                        <el-descriptions-item>系统使用率</el-descriptions-item>
                        <el-descriptions-item>{{ cpu && cpu.cpu_system }}%</el-descriptions-item>
                        <el-descriptions-item>当前空闲率</el-descriptions-item>
                        <el-descriptions-item>{{ cpu && cpu.cpu_idle }}%</el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card noBorder">
                    <template #header>
                        <div class="card-header">
                            <span>内存</span>
                        </div>
                    </template>
                    <el-descriptions direction="vertical" :column="2" :size="size" border class="desc-list">
                        <el-descriptions-item label="属性">总内存</el-descriptions-item>
                        <el-descriptions-item label="内存">{{ memory && memory.memory_total }}</el-descriptions-item>
                        <el-descriptions-item>已用内存</el-descriptions-item>
                        <el-descriptions-item>{{ memory && memory.memory_used }}</el-descriptions-item>
                        <el-descriptions-item>剩余内存</el-descriptions-item>
                        <el-descriptions-item>{{ memory && memory.memory_free }}</el-descriptions-item>
                        <el-descriptions-item>使用率</el-descriptions-item>
                        <el-descriptions-item>{{ memory && memory.memory_percent }}%</el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </el-col>
        </el-row>
        <el-card class="box-card noBorder">
            <template #header>
                <div class="card-header">
                    <span>服务器信息</span>
                </div>
            </template>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="服务器名称">{{ server && server.hostname }}</el-descriptions-item>
                <el-descriptions-item label="操作系统">{{ server && server.system_name }}</el-descriptions-item>
                <el-descriptions-item label="服务器IP">{{ server && server.server_ip }}</el-descriptions-item>
                <el-descriptions-item label="系统架构">{{ server && server.system_arch }}</el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card class="box-card noBorder">
            <template #header>
                <div class="card-header">
                    <span>磁盘状态</span>
                </div>
            </template>
            <el-table :data="disk" border style="width: 100%">
                <el-table-column prop="device" label="盘符路径" />
                <el-table-column prop="fs_type" label="文件系统" />
                <el-table-column prop="mount_point" label="盘符类型" />
                <el-table-column prop="disk_total" label="总大小" />
                <el-table-column prop="disk_free" label="可用大小" />
                <el-table-column prop="disk_used" label="已用大小" />
                <el-table-column
                    prop="disk_percent"
                    label="已用百分比"
                    :formatter="
                        (row, column, cellValue, index) => {
                            return cellValue + '%'
                        }
                    "
                />
            </el-table>
        </el-card>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { getService } from '@/api/monitor.js'

const size = ref('default')
onMounted(() => {
    getServiceFun()
})
const cpu = ref({})
const memory = ref({})
const disk = ref([])
const server = ref({})

const getServiceFun = () => {
    getService().then((data) => {
        cpu.value = data.cpu
        memory.value = data.memory
        disk.value = data.disk
        server.value = data.server
    })
}
</script>
<style scoped lang="scss">
.container-server {
    .el-card {
        margin-bottom: 20px;
    }

    .desc-list {
        :deep(.el-descriptions__body .el-descriptions__table tr:not(:first-child):nth-child(odd)) {
            display: none !important;
        }
    }
}
</style>
